import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';

import { setAlarm, setFilter, setCountries } from '../../../redux/actions/general';
import { URL_PARAMS } from '../../../urlSync/urlParamNames';

import { Button, Col, Row } from 'reactstrap';

import storePropTypes from '../../../redux/store/propTypes';
import { PropTypes } from 'prop-types';

import {
   timespanChanged,
   orgaHashChanged,
   filterDataNotYetFetched,
   filterChanged,
} from '../../../redux/selectors/comparing';
import {
   WidgetBodyContainer,
   WidgetContainer,
   WidgetHeaderContainer,
} from '../../../styledComponents/styledComponents';
import { DefaultGrey } from '../../../constants/colors';
import { HISTORY_VIEW } from '../../../constants/general';
import * as browserStorage from '../../../misc/BrowserStorageManager';

const mapStateToProps = (state) => {
   return state.general;
};

const mapDispatchToProps = { setCountries, setFilter, setAlarm };

let countriesIsBeingFetched = false;

class CountryFilter extends Component {
   constructor(props) {
      super(props);

      this.state = {
         countries: [],
         filter: {
            countries: props.filter.countries,
         },
      };
   }

   // collect user selection(s), but don't trigger a dispatch
   handleChange = (selectedOptions) => {
      const selectedCountries = selectedOptions === null ? [] : selectedOptions;
      this.setState({ filter: { countries: selectedCountries } });
      if (selectedCountries.length === 0) {
         this.props.setFilter(
            { ...this.props.filter, countries: [] },
            { [URL_PARAMS.COUNTRIES]: [] },
         );
      }
   };

   applySelection = () => {
      this.props.setFilter(
         {
            ...this.props.filter,
            countries: this.state.filter.countries,
         },
         { [URL_PARAMS.COUNTRIES]: this.state.filter.countries },
      );
   };

   getCountries(timespan, filter, cancelToken, view) {
      const self = this;

      let token = browserStorage.getJwtToken();

      let headerObj = {
         'x-access-token': token,
         Accept: 'application/json',
         'Content-Type': 'application/json;charset=UTF-8',
      };

      if (filter.hash !== '') {
         headerObj['x-orga-hash'] = filter.hash;
      }

      axios
         .get(
            `/v2/filters/countries?from=${timespan.gte.format()}&to=${timespan.lt.format()}${
               view === HISTORY_VIEW ? '&storage=longterm' : ''
            }`,
            {
               headers: headerObj,
               cancelToken: cancelToken.token,
            },
         )
         .then(function (response) {
            const countries = response.data.data.map((bucket) => {
               return {
                  value: bucket.filterValue,
                  label: bucket.countryName,
               };
            });

            self.props.setCountries(countries);

            // Reconcile labels: URL-loaded entries only have ISO code as label,
            // replace with full country names from the fetched options.
            const reconciledSelection = filter.countries.map((selected) => {
               const match = countries.find((c) => c.value === selected.value);
               return match ?? selected;
            });
            self.setState({ filter: { countries: reconciledSelection } });
         })
         .catch((error) => {
            if (error instanceof axios.Cancel) {
               return;
            }
            if (process.env.NODE_ENV === 'development') {
               console.error(error);
            }
         })
         .finally(function () {
            countriesIsBeingFetched = false;
         });
   }

   componentWillReceiveProps(nextProps) {
      if (
         timespanChanged(this.props, nextProps) ||
         orgaHashChanged(this.props, nextProps) ||
         filterDataNotYetFetched(nextProps, 'countries', countriesIsBeingFetched)
      ) {
         countriesIsBeingFetched = true;
         this.getCountries(nextProps.timespan, nextProps.filter, nextProps.cancelToken, nextProps.currentView);
      }

      // required for URL sync: if countries filter is set by URL (with no hash/timespan change)

      if (filterChanged(this.state.filter.countries, nextProps.filter.countries)) {
         this.setState({ filter: { countries: nextProps.filter.countries } });
      }
   }

   render() {
      return (
         <div style={{ position: 'relative', zIndex: 14 }} className='animated fadeIn'>
            <Row>
               <Col>
                  <WidgetContainer>
                     <WidgetHeaderContainer $bgColor={DefaultGrey(1, 247)}>
                        <strong>Country filter</strong>
                     </WidgetHeaderContainer>
                     <WidgetBodyContainer>
                        <div className='customRow'>
                           <div className='selectCol'>
                              <Select
                                 value={this.state.filter.countries}
                                 onChange={this.handleChange}
                                 options={this.props.countries}
                                 isMulti={true}
                                 closeMenuOnSelect={false}
                              />
                           </div>
                           <div className='buttonCol'>
                              <Button
                                 color='primary'
                                 outline={!filterChanged(this.state.filter.countries, this.props.filter.countries)}
                                 disabled={!filterChanged(this.state.filter.countries, this.props.filter.countries)}
                                 style={!filterChanged(this.state.filter.countries, this.props.filter.countries) ? { borderColor: 'rgb(230, 230, 230)', color: '#73818f', opacity: 1, cursor: 'not-allowed', pointerEvents: 'auto' } : {}}
                                 onClick={this.applySelection}
                              >
                                 Go
                              </Button>
                           </div>
                        </div>
                     </WidgetBodyContainer>
                  </WidgetContainer>
               </Col>
            </Row>
         </div>
      );
   }
}

CountryFilter.propTypes = {
   filter: storePropTypes.filter,
   timespan: storePropTypes.timespan,
   countries: storePropTypes.countries,
   cancelToken: storePropTypes.cancelToken,
   setCountries: PropTypes.func,
   setFilter: PropTypes.func,
   setAlarm: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CountryFilter);
